export default __webpack_public_path__ + "static/bed-bath-beyond-2-b64a8d0a27fa82854790c451cd79df61.webp";